/**
 * Parses and applies lane options from the DOM dataset and elements.
 *
 * @property {import('vue').Component} component - The Vue component instance.
 * @method parseOptions - Reads data-* attributes and updates component state accordingly.
 */
export default class LaneOptions {
	constructor(component) {
		this.component = component;
		this.parseOptions();
	}

	parseOptions() {
		const el = this.component.$el;

		this.component.orientation = this.component.$el.dataset.orientation === 'vertical' ? 'vertical' : 'horizontal';

		if(this.component.$el.dataset.infinityLoop === 'true')
			this.component.optionInfinity = true;


		const startPositionEl = el.querySelector('[data-start-position]');
		if (startPositionEl && startPositionEl.dataset.startPosition === 'center') {
			this.component.startPosition = 'center';
			const halfWidth = this.component.totalWidth / 2;
			const centerPosition = halfWidth - this.component.lane.clientWidth / 2;
			this.component.scrollLeft = this.component.lane.scrollLeft = centerPosition;
		}

		const viewportTriggerEl = el.querySelector('[data-viewport-active-item-trigger]');
		if (viewportTriggerEl && viewportTriggerEl.dataset.viewportActiveItemTrigger === 'center') {
			this.component.viewportActiveItemTrigger = 'center';
		}

		const scrollableEl = el.querySelector('[data-scrollable]');
		if (scrollableEl && scrollableEl.dataset.scrollable === 'false') {
			this.component.scrollableAllowed = false;
			this.component.scrollable = false;
		}

		const itemsClickEl = el.querySelector('[data-items-click-to-center]');
		if (itemsClickEl  && itemsClickEl.dataset.itemsClickToCenter === 'true') {
			this.component.itemsClickToCenterEnabled = true;
		}

		const autoScrollEl = el.querySelector('[data-auto-scroll]');
		if (autoScrollEl && autoScrollEl.dataset.autoScroll === 'true') {
			this.component.autoScroll = true;
		}

		const autoScrollReversedEl = el.querySelector('[data-auto-scroll-reversed]');
		if (autoScrollReversedEl && autoScrollReversedEl.dataset.autoScrollReversed === 'true') {
			this.component.autoScrollReversed = true;
		}

		const autoScrollSpeedEl = el.querySelector('[data-auto-scroll-speed]');

		if (autoScrollSpeedEl) {
			this.component.autoScrollSpeed = parseFloat(autoScrollSpeedEl.dataset.autoScrollSpeed);
		}

		const autoScrollPauseEl = el.querySelector('[data-auto-scroll-item-hover-pause]');

		if (autoScrollPauseEl && autoScrollPauseEl.dataset.autoScrollItemHoverPause === 'true') {
			this.component.autoScrollItemHoverPause = true;
		}
	}
}
